export default __webpack_public_path__ + "2284faf802285e5baa211f1154d3bc75.png";